<template>
  <div
    v-if="props?.status && props.status !== 'published'"
    class="page-status"
  >
    <p>{{ props.status }}</p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  status?: string,
}>()
</script>

<style scoped lang="postcss">
.page-status {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(102, 68, 255);
  pointer-events: none;
  user-select: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 8px;
  filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.25));
  font-family: -apple-system, "system-ui", "Segoe UI", Roboto, Helvetica, Arial,
  sans-serif;
  font-size: 12px;
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  z-index: 2000;
}

</style>
